/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { SetStateAction, useEffect, useState } from 'react';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';
import './inputTags.component.css';

interface InputTagsProps {
  items: Array<string>
  diagnosisCode:string
  setInputTagsValues: React.Dispatch<SetStateAction<string[]>>
  labelText:string
  index:number
}

const InputTags: React.FC<InputTagsProps> = ({ items, diagnosisCode, setInputTagsValues, labelText, index }) => {
  const { updateDiagnosisCodes } = usePADomainModel();
  const [isValid, setIsValid] = useState<boolean>(true);
  const [isDiagnosticCodeSame, setIsDiagnosticCodeSame] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState('');
  const { updateDiagnosticValidationStatus } = usePADomainModel();

  useEffect(() => {
    setTags(items);
    if (items.includes(diagnosisCode.toUpperCase())) {
      updateDiagnosticValidationStatus((index + 1).toString(), false);
      setIsDiagnosticCodeSame(true);
    }
    setInputTagsValues(items);
  }, [items.length]);

  const [tags, setTags] = useState<string[]>([]);

  const handleTagsChange = (newTags: string[]) => {
    const newTagsMapped = newTags.map((tag) => tag.toUpperCase());
    const lastTag = newTagsMapped[newTagsMapped.length - 1];
    if (validateInput(lastTag)) {
      validateSameDiagnosticCode(lastTag);
      setTags(newTagsMapped);
      setInputTagsValues(newTagsMapped);
      updateDiagnosisCodes(index, newTagsMapped);
      setInputValue('');
    }
  };

  const handleInputChange = (input:string) => {
    const inputUpper = input.toUpperCase();
    setInputValue(inputUpper);
    validateInput(inputUpper);
  };
  const validateSameDiagnosticCode = (tag:string) => {
    if (tag === diagnosisCode.toUpperCase()) {
      updateDiagnosticValidationStatus((index + 1).toString(), false);
      setIsDiagnosticCodeSame(true);
      return true;
    }
    updateDiagnosticValidationStatus((index + 1).toString(), true);
    setIsDiagnosticCodeSame(false);
    return false;
  };

  const validateInput = (tag:string) => {
    if (tag) {
      const pattern = /^[A-TV-Z][0-9A-Z]{2}(?:\.[0-9A-Zx]{1,4})?$/i;
      const validate = tag.trim() === '' || pattern.test(tag);
      setIsValid(validate);
      return validate;
    }
    setIsValid(true);
    return true;
  };

  return (
    <div data-testid="inputTags">
      <label className="fw-bold mb-0">{labelText}</label>
      <div>Type a diagnosis code with three to seven characters and hit 'Enter' to add it. Please be sure to enter accurate diagnosis code(s) to avoid delays.</div>
      <TagsInput value={tags} onChange={handleTagsChange} onChangeInput={handleInputChange} inputValue={inputValue} />
      {(!isValid) && (<div className="tagInputErrorMessage" data-testid={`tagInputErrorMessage-${index}`}>Please enter a valid ICD-10 diagnosis code:</div>)}
      {(isDiagnosticCodeSame) && (<div className="tagInputErrorMessage" data-testid={`tagInputDuplicodeErrorMessage-${index}`}> Diagnosis code entered is duplicate to the Primary Diagnosis code already entered. Please delete the duplicate Diagnosis code prior to submitting.</div>)}
    </div>
  );
};

export default InputTags;
